// An engagement signal, not a claim that someone understood the article.
// Background tabs and time while the article is outside the viewport do not count.
export class ProductUpdateReadProgress {
  constructor() {
    this.visibleSeconds = 0;
    this.scrollPercent = 0;
  }

  sample({ visible, seconds, top, bottom, height, viewportHeight }) {
    if (!visible || height <= 0 || bottom <= 0 || top >= viewportHeight) return;

    this.visibleSeconds += Math.max(0, Math.min(seconds, 1));
    const percent = Math.max(0, Math.min(100, ((viewportHeight - top) / height) * 100));
    this.scrollPercent = Math.max(this.scrollPercent, percent);
  }

  get ready() {
    return this.visibleSeconds >= 15 && this.scrollPercent >= 80;
  }

  get payload() {
    return { visible_seconds: Math.floor(this.visibleSeconds), scroll_percent: Math.floor(this.scrollPercent) };
  }
}
